<div class="col-xl">
    <!-- Dynamic suppliers section -->
    <form [formGroup]="form">
        <div formArrayName="suppliers" class="row">
            <div class="col-lg-12" *ngFor="let supplier of suppliers.controls; let i = index" [formGroupName]="i">
                <div class="card mb-4 rounded selectable" [class.selected]="selectedIndex === i" (click)="selectCard(i)">
                    <div class="card-header d-flex justify-content-between align-items-center pb-3">
                        <h4 class="mb-0">Proveedor {{ indexToLetter(i) }}</h4>
                    </div>
                    <div class="card-body">
                        <div class="mb-3 p-4 border rounded">
                            <div class="row">
                              <div class="col-lg-6">
                                <div class="row">
                                <div class="col-lg-12 col-xs-12 position-relative">
                                    <h6 class="mb-1"><b>{{!isExternal ? 'Nombre de refaccionaria' : 'Nombre del taller'}}</b></h6>
                                    <input type="text" placeholder="Ingresar" class="form-control" formControlName="workshop_name">
                                </div>
                                <div class="col-lg-12 col-xs-12">
                                    <h6 class="mb-1 mt-3"><b>Ubicación {{!isExternal ? 'de refaccionaria' : 'del taller'}}</b></h6>
                                    <div class="input-group ubicacion">
                                      <span class="input-group-text">
                                        <img src="assets/img/icons/maintenance/elements.svg" alt="">
                                      </span>
                                      <input type="text" placeholder="Ingresar" class="form-control" formControlName="workshop_location" [appGooglePlaces]="suppliers.at(i).get('workshop_location')">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-xs-12">
                                    <h6 class="mb-1 mt-3"><b>{{!isExternal ? 'Costo de la refaccionaria' : 'Costo del taller'}}</b></h6>
                                    <input type="text"
                                           inputmode="decimal"
                                           placeholder="$0.00"
                                           class="form-control"
                                           formControlName="service_cost"
                                           [imask]="costMask"
                                           [unmask]="false">
                                </div>
                                <div class="col-lg-12 col-xs-12">
                                    <h6 class="mb-1 mt-3"><b>Tiempo estimado {{!isExternal ? 'de la refaccionaria' : 'del taller'}}</b></h6>
                                    <input type="text" placeholder="Ingresar" class="form-control" formControlName="estimated_time">
                                </div>
                                <div class="col-lg-12 col-xs-12 mt-3">
                                    <!-- Show existing attached_url when no new file is selected -->
                                    <div class="d-flex align-items-center mt-2"
                                         *ngIf="!(suppliers.at(i).get('evidences')?.value?.length) && (suppliers.at(i).get('attached_url')?.value)">
                                        <img src="assets/img/icons/maintenance/pdf-02.svg" alt="PDF" width="20" class="me-2">
                                        <a class="me-2" [href]="urlPage + '/storage/' + suppliers.at(i).get('attached_url')?.value" target="_blank" rel="noopener">
                                            Ver cotización existente
                                        </a>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-xs-12">
                                    <h6 class="mb-1 mt-3"><b>Banco</b></h6>
                                    <select class="form-select" formControlName="bank_id">
                                        <option [ngValue]="null">Seleccione</option>
                                        <option *ngFor="let b of dataBank" [ngValue]="b.id">{{ b.name }}</option>
                                    </select>
                                </div>
                                <div class="col-lg-12 col-xs-12">
                                    <h6 class="mb-1 mt-3"><b>Número de cuenta</b></h6>
                                    <input type="text"
                                           inputmode="numeric"
                                           placeholder="#### #### #### ####"
                                           class="form-control"
                                           formControlName="account_number"
                                           [imask]="accountMask"
                                           [unmask]="false">
                                </div>
                                <div class="col-lg-12 col-xs-12">
                                    <h6 class="mb-1 mt-3"><b>Nombre del titular</b></h6>
                                    <input type="text" placeholder="Ingresar" class="form-control" formControlName="account_holder">
                                </div>
                                <div class="col-lg-12 col-xs-12">
                                    <h6 class="mb-1 mt-3"><b>Tipo de pago</b></h6>
                                    <select class="form-select" formControlName="payment_type_id">
                                        <option [ngValue]="null">Seleccione</option>
                                        <option *ngFor="let p of dataPaymentType" [ngValue]="p.id">{{ p.name }}</option>
                                    </select>
                                </div>
                                </div>
                              </div>
                              <div class="col-lg-6 border-start">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <h6 class="mb-0"><b>Materiales y refacciones</b></h6>
                                </div>
                                <p class="text-muted" *ngIf="repairItems(i).length === 0">Sin refacciones registradas</p>
                                <div formArrayName="repair_items" class="repairs-list pe-1">
                                    <div class="repair-card border rounded p-3 mb-3" *ngFor="let item of repairItems(i).controls; let j = index" [formGroupName]="j">
                                        <div class="d-flex justify-content-between align-items-center mb-2">
                                            <h6 class="mb-0"><b>Refacción #{{ j + 1 }}</b></h6>
                                        </div>
                                        <input type="text" placeholder="Ingresar" class="form-control" formControlName="name">
                                        <div class="row mt-2">
                                            <div class="col-4">
                                                <h6 class="mb-1"><b>Cantidad</b></h6>
                                                <div class="input-group qty-group">
                                                    <input type="number" class="form-control border-end-0" formControlName="quantity">
                                                    <span class="input-group-text qty-stepper">
                                                        <button type="button" tabindex="-1" disabled><span class="chev up"></span></button>
                                                        <button type="button" tabindex="-1" disabled><span class="chev down"></span></button>
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-8">
                                                <h6 class="mb-1"><b>Subtotal</b></h6>
                                                <div class="input-group money-group">
                                                    <span class="input-group-text">$</span>
                                                    <input type="text" placeholder="Ingresar" class="form-control border-start-0 ps-0" formControlName="subtotal">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="repairs-total-strip d-flex justify-content-between align-items-center rounded px-3 py-2 mb-3"
                                     *ngIf="repairItems(i).length > 0">
                                    <strong>Total refacciones:</strong>
                                    <span class="fw-bold fs-5">${{ formatAmount(getRepairTotal(i)) || '0' }} <small class="fs-6">MXN</small></span>
                                </div>
                                <hr>
                                <h6 class="mb-1"><b>Mano de obra</b></h6>
                                <h6 class="mb-1 mt-3"><b>Costo de mano de obra</b></h6>
                                <div class="input-group money-group">
                                    <input type="text" placeholder="—" class="form-control border-end-0" formControlName="labor_cost">
                                    <span class="input-group-text">MXN</span>
                                </div>
                                <h6 class="mb-1 mt-3"><b>Descripción</b></h6>
                                <input type="text" placeholder="—" class="form-control" formControlName="labor_description">
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="row">
        <div class="col-lg-12 text-center">
            <div class="btn-actions">
                <button class="btn btn-outline-primary btn-equal" (click)="submit(1)">
                    Denegar Autorización
                </button>
                <button class="btn btn-primary btn-equal" (click)="submit(2)" [disabled]="selectedIndex === null">
                    Autorizar
                </button>
            </div>
        </div>
    </div>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>

<!-- Modal -->
<div class="modal fade" id="ModalDenegar" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="ModalDenegarLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header d-flex justify-content-center">
                <h4 class="modal-title text-center lh-1" id="ModalDenegarLabel">¿Estas seguro que deseas denegar esta solicitud?</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body text-center mb-0 pb-0">
                <p class="lh-1">Una vez rechazada la solicitud no se podrá recuperar esta solicitud y se deberá solicitar nuevamente.</p>
            </div>
            <div class="modal-footer">
                <div class="col">
                    <button type="button" class="btn btn-outline-primary w-100" data-bs-dismiss="modal">Cancelar</button>
                </div>
                <div class="col">
                    <button type="button" class="btn btn-primary w-100" (click)="sendData()">Denegar</button>
                </div>
            </div>
        </div>
    </div>
</div>